var React = require('react');

function StarWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M120 30L138.635 50.4533L165 42.0577L170.912 69.0883L197.942 75L189.547 101.365L210 120L189.547 138.635L197.942 165L170.912 170.912L165 197.942L138.635 189.547L120 210L101.365 189.547L75 197.942L69.0883 170.912L42.0577 165L50.4533 138.635L30 120L50.4533 101.365L42.0577 75L69.0883 69.0883L75 42.0577L101.365 50.4533L120 30Z","fill":"white"}));
}

StarWhite.defaultProps = {"width":"240","height":"240","viewBox":"0 0 240 240","fill":"none"};

module.exports = StarWhite;

StarWhite.default = StarWhite;
